import store from '../store/index'
import createNewCharacteristicEntries from './createNewCharacteristicEntries'
//----------------------
// set character values
//----------------------
export default function setCharacterValues(default_race) {
  console.log('----------------------------')
  console.log('IN setCharacterValues')
  // -------------------------
  // get default campaign details
  // -------------------------
  let arena = store.getters['combat/getCampaign']
  // -------------------------
  // get default race details
  // -------------------------
  const allRaces = store.getters['races/getRaces'] || []
  const characterRaces = store.getters['races/getCharacterRaces'] || []
  const availableRaces = characterRaces.length > 0 ? characterRaces : allRaces
  let race =
    availableRaces.find((entry) => entry.name == default_race) ||
    allRaces.find((entry) => entry.name == default_race) ||
    availableRaces[0] ||
    allRaces[0]
  //---------------------------------------------
  // get race characteristics  (default - human)
  //---------------------------------------------
  const race_chars =
    race?.characteristics || store.getters['races/getRaceCharacteristics'](race?.id) || []
  //
  const race_str = race_chars.find((c) => c.name == 'str')
  const race_con = race_chars.find((c) => c.name == 'con')
  const race_dex = race_chars.find((c) => c.name == 'dex')
  const race_siz = race_chars.find((c) => c.name == 'siz')
  const race_int = race_chars.find((c) => c.name == 'int')
  const race_pow = race_chars.find((c) => c.name == 'pow')
  const race_cha = race_chars.find((c) => c.name == 'cha')
  // ---------------------------
  // define character structure
  // ---------------------------
  let character = {
    // --------
    // PROFILE
    // --------
    arena_name: arena?.name || '',
    arena: arena?.id || null,
    slug: '',
    id: 0,
    race_name: race?.name || default_race,
    status: 'Alive',
    category: 'Party',
    type: 'Character',
    player: null,
    role: 'Warrior',
    cults: '',
    profession: '',
    notes: '',
    wounds: 0,
    fatigue: 'Fresh',
    fatigue_override: null,
    //
    gender: 'Male',
    age: 25,
    height: 180,
    weight: 85,
    cock: 3,
    colour_eyes: 'Brown',
    colour_hair: 'Brown',
    distinguishing_marks: '',
    //
    image: null,
    image_file: null,
    // ----------
    // ABILITIES
    // ----------
    ca_cur: 0,
    ca_base: race.ca,
    ca_adjs_tot: 0,
    //
    cr_cur: 0,
    cr_base: race.cr,
    cr_adjs_tot: 0,
    //
    sr_cur: 0,
    sr_base: race.sr,
    sr_adjs_tot: 0,
    //
    damage_mod_melee_cur: 0,
    damage_mod_melee_base: race.damage_mod,
    damage_mod_melee_adjs_tot: 0,
    //
    damage_mod_ranged_cur: 0,
    damage_mod_ranged_base: race.damage_mod,
    damage_mod_ranged_adjs_tot: 0,
    //
    move_cur: 0,
    move_base: race.move,
    move_adjs_tot: 0,
    //
    move_fly_cur: 0,
    move_fly_base: race.move_fly,
    move_fly_adjs_tot: 0,
    //
    know_bonus_percent: 0,
    // -------------------------
    // HEADLINE CHARACTERISTICS
    // -------------------------
    str_rolled: race_str.value,
    str_cur: race_str.value,
    str_improvs_tot: 0,
    str_incr_percent: 0,
    str_adjs_tot: 0,
    str_min: race_str.min,
    str_max: race_str.max,
    //
    con_rolled: race_con.value,
    con_cur: race_con.value,
    con_improvs_tot: 0,
    con_incr_percent: 0,
    con_wounds_tot: 0,
    con_adjs_tot: 0,
    con_min: race_con.min,
    con_max: race_con.max,
    //
    dex_rolled: race_dex.value,
    dex_cur: race_dex.value,
    dex_improvs_tot: 0,
    dex_incr_percent: 0,
    dex_adjs_tot: 0,
    dex_min: race_dex.min,
    dex_max: race_dex.max,
    //
    siz_rolled: race_siz.value,
    siz_cur: race_siz.value,
    siz_improvs_tot: 0,
    siz_incr_percent: 0,
    siz_adjs_tot: 0,
    siz_min: race_siz.min,
    siz_max: race_siz.max,
    //
    int_rolled: race_int.value,
    int_cur: race_int.value,
    int_improvs_tot: 0,
    int_incr_percent: 0,
    int_adjs_tot: 0,
    int_min: race_int.min,
    int_max: race_int.max,
    //
    pow_rolled: race_pow.value,
    pow_cur: race_pow.value,
    pow_improvs_tot: 0,
    pow_incr_percent: 0,
    pow_integs_tot: 0,
    pow_adjs_tot: 0,
    pow_min: race_pow.min,
    pow_max: race_pow.max,
    //
    cha_rolled: race_cha.value,
    cha_cur: race_cha.value,
    cha_improvs_tot: 0,
    cha_incr_percent: 0,
    cha_adjs_tot: 0,
    cha_min: race_cha.min,
    cha_max: race_cha.max,
    // -------
    // ARRAYS
    // -------
    skills: [],
    items: [],
    non_rune_spells: [],
    runes: [],
    ability_adjs: [],
    skill_adjs: [],
    characteristic_adjs: [],
    characteristic_skill_adjs: [],
    // -----------------------------------------------
    // CHARACTERISTICS ARRAY (BASED ON RACE DEFAULTS) [placeholder for adj arrays]
    // -----------------------------------------------
    characteristics: createNewCharacteristicEntries(race_chars),
    // ---------------
    // COMBAT OPTIONS
    // ---------------
    combat_inclusion: true,
    second_weapon: false,
    shield: false,
    ranged: false,
    magic: false,
    special_action: false,
    special_reaction: false,
    // -----
    // MISC
    // -----
    mp: race_pow.value,
    mp_cur: race_pow.value,
    dex_pen_percent_armour: 0,
    // ENC fields (mirrors backend behaviour for new characters)
    // max_enc is approximated as STR + (2 * SIZ) using race defaults;
    // cur_enc starts at 0 and will be recomputed client-side
    // when starter items are attached.
    max_enc: race_str.value + 2 * race_siz.value,
    cur_enc: 0,
  }
  // --------------------------------------
  // if player creation - set player name
  // --------------------------------------
  const player = store.getters['auth/getUserProfile']
  const isPlayerCreation = !arena?.dm || arena.dm.user_name !== player?.user_name

  if (isPlayerCreation) {
    character.player_name = player?.first_name || player?.user_name || ''
  }
  return character
}
